export const selectedCountLabel = (selected?: (string | number)[]) =>
  selected?.length ? ` (${selected.length})` : '';
